import React, { useEffect, useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sp4eZStgLM4H2n9wSDSXj9/ChatGPT_Image_Feb_1,_2026,_08_32_42_AM.png';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-3'}`} data-id="element-138">
      {/* Top row: Phone left, Logo center, CTA right */}
      <div className="container mx-auto px-4 md:px-6" data-id="element-139">
        <div className="flex items-center justify-between" data-id="element-140">
          {/* Phone - left */}
          <a href="tel:07355854313" className="hidden md:flex items-center gap-2 text-gray-800 font-semibold hover:text-teal-600 transition-colors" data-id="element-141">
            <Phone className="w-5 h-5 text-teal-600" data-id="element-142" />
            07355 854313
          </a>

          {/* Logo - center */}
          <a href="#home" className="flex items-center group absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0 md:flex-1 md:justify-center" data-id="element-143">
            <img src={LOGO_URL} alt="CleenCo - Professional Cleaning Solutions" className="h-16 md:h-20 w-auto object-contain" data-id="element-144" />
          </a>

          {/* CTA - right */}
          <a href="#contact" className="hidden md:inline-flex bg-teal-600 hover:bg-teal-700 text-white px-6 py-2.5 rounded-full font-semibold transition-all shadow-lg shadow-teal-600/20 hover:shadow-teal-600/40 transform hover:-translate-y-0.5" data-id="element-145">
            Get a Quote
          </a>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-600 hover:text-teal-600 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-146">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-147" /> : <Menu className="w-6 h-6" data-id="element-148" />}
          </button>
        </div>

        {/* Desktop Nav - below logo */}
        <nav className="hidden md:flex items-center justify-center gap-8 mt-2 pb-1" data-id="element-149">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-teal-600 font-medium transition-colors text-sm uppercase tracking-wide" data-id="element-150">
              {link.name}
            </a>)}
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-151">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-152">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-153">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-gray-800 hover:text-teal-600 py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-154">
                  {link.name}
                </a>)}
              <div className="mt-4 flex flex-col gap-4" data-id="element-155">
                <a href="tel:07355854313" className="flex items-center gap-3 text-lg font-semibold text-gray-800" data-id="element-156">
                  <div className="w-10 h-10 bg-teal-50 rounded-full flex items-center justify-center" data-id="element-157">
                    <Phone className="w-5 h-5 text-teal-600" data-id="element-158" />
                  </div>
                  07355 854313
                </a>
                <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-teal-600 text-white text-center py-3 rounded-lg font-bold shadow-md" data-id="element-159">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}